import styled from 'styled-components'
import { AutoConfigStylesProps } from './Interface'
import { cyberColors, colors } from '../../../lib/colors'

export const AutoConfigWrapper = styled.div`
  width: 100%;
`
export const SavedConfigWrapper = styled.div<AutoConfigStylesProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: ${({ emptyConfig }: any) => (emptyConfig ? 'center' : '')};
  width: 95px;
  height: 35px;
  background: ${({ emptyConfig, rollUnder }: any) =>
    emptyConfig
      ? colors.primaryDark
      : rollUnder == '1'
      ? cyberColors.blueGradient
      : cyberColors.redGradient};
  color: ${({ emptyConfig }: any) => (emptyConfig ? cyberColors.greyText : '')};
  border-radius: 4px;
  margin-top: 15px;
  cursor: ${({ emptyConfig }: any) =>
    emptyConfig ? 'not-allowed' : 'pointer'};
  opacity: ${({ emptyConfig, isActive }: any) =>
    emptyConfig || !isActive ? 0.5 : 1};
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 4px 10.75px 6.05px 10px;
`
export const Title = styled.div<AutoConfigStylesProps>`
  color: ${({ rollUnder }: any) =>
    rollUnder == '0' ? cyberColors.redText : cyberColors.blueText};
  font-size: 12px;
`
export const Number = styled.div`
  color: ${cyberColors.whiteText};
  font-size: 16px;
`

export const DiceWrapper = styled.div`
  position: relative;
  width: 20px;
  display: flex;
  margin-top: 1px;
  svg {
    width: 14.74px;
    height: 14.61px;
    &:nth-child(2) {
      position: absolute;
      bottom: 0px;
      left: 5px;
    }
  }
`
